import React from 'react';
import {
    Button
} from 'reactstrap';
import ScrollAnimation from 'react-animate-on-scroll'
import { Link } from 'react-router-dom'
import './styles/card.css'
import Icon from './styles/icon'


const MyCard = (props) => {
    return (
        <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={props.delay}>
            <div className="mycard">
                <img src={props.data.img} className="mycard-img" alt="paithani type" />
                <div className="card-title">{props.data.title}
                    <Link to="/gallery" style={{ float: 'right', marginBottom: 4 }}>
                        <Button className="card-btn" size="sm">
                            View <Icon icon="fa-angle-right" /></Button>

                    </Link>
                </div>
            </div>
        </ScrollAnimation>
    );
};

export default MyCard;


// WEBPACK FOOTER //
// ./src/MyCard.js